var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"unstyled bug",class:[_vm.promptInject ? 'active' : ''],attrs:{"aria-hidden":"true","tabindex":"-1"},on:{"click":function($event){return _vm.togglePromptInject()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }